import { render, staticRenderFns } from "./formCreateOrder.vue?vue&type=template&id=28eb90ea"
import script from "./formCreateOrder.vue?vue&type=script&lang=js"
export * from "./formCreateOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28eb90ea')) {
      api.createRecord('28eb90ea', component.options)
    } else {
      api.reload('28eb90ea', component.options)
    }
    module.hot.accept("./formCreateOrder.vue?vue&type=template&id=28eb90ea", function () {
      api.rerender('28eb90ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/order/components/form/formCreateOrder.vue"
export default component.exports